import { useSelector } from 'react-redux';
import { selectLocale } from '@store/app';

export const useLocale = () => useSelector(selectLocale);
